<div class="boletas-container">
  <!-- Título y subtítulo -->
  <app-page-header
    [title]="'Boletas'"
    [subtitle]="'Administra tus boletas y facturas'"
  ></app-page-header>

  <!-- Botones, combo y barra de búsqueda -->
  <app-page-acciones
    [comboOptions]="monthOptions"
    [comboSelected]="currentMonth"
    (comboSelectedChange)="onMonthChange($event)"

    [yearOptions]="yearOptions"
    [yearSelected]="selectedYear"
    (yearSelectedChange)="onYearChange($event)"

    [searchQuery]="searchTerm"
    (searchQueryChange)="onSearch($event)"
  >
  </app-page-acciones>

  <!-- Tabs y tabla dinámica -->
  <app-page-container
    [tabs]="tabs"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [serverSidePagination]="true"
    [totalElements]="totalElements"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [actionButtons]="actionButtons"
    [showPreviewCard]="true"
    [isLoading]="isLoading"
    [customTemplates]="{
      paymentSlipAmount: paymentSlipAmountTemplate,
      employeeName: employeeNameTemplate
    }"
    (tabSelected)="onTabSelected($event)"
    (rowSelected)="onRowSelected($event)"
    (pageChange)="onPageChange($event)"
    [selectedDocument]="selectedDocument"
    [hasCheckbox]="true"
  >
    <ng-template #paymentSlipAmountTemplate let-row>
      {{ row.paymentSlipAmount | currencySymbol : row.currencyId }}
    </ng-template>
    <ng-template #employeeNameTemplate let-row>
      {{ row.employeeName | capitalize }}
    </ng-template>
  </app-page-container>

  <div class="payment-validate-modal">
    <app-payment-validate-modal
      [(visible)]="mostrarModalValidar"
      [dataToView]="dataToUpdate"
      (visibleChange)="onDialogDetailClose()"
      (updateStateComplete)="onUpdateStateComplete()"
    >
    </app-payment-validate-modal>
  </div>

  <!-- Modal del detalle -->
  <div class="payment-detail-modal">
    <app-detail-modal
      [(visible)]="mostrarModalDetalle"
      [dataToView]="dataDetail"
      (visibleChange)="onDialogDetailClose()"
    ></app-detail-modal>
  </div>
</div>
